var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcoTooltipSignup = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 37,
  height: 37,
  viewBox: "0 0 37 37"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#1274C4",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18 20c-2.217 0-4.019-1.794-4.019-4s1.802-4 4.019-4 4.019 1.794 4.019 4-1.802 4-4.019 4m3.776.673a5.978 5.978 0 0 0 2.182-5.603c-.397-2.623-2.589-4.722-5.236-5.028-3.652-.423-6.75 2.407-6.75 5.958 0 1.89.88 3.574 2.252 4.673-3.372 1.261-5.834 4.222-6.22 8.218A1.012 1.012 0 0 0 9.009 30a.99.99 0 0 0 .993-.891C10.404 24.646 13.837 22 18 22s7.596 2.646 7.999 7.109a.99.99 0 0 0 .993.891c.596 0 1.06-.518 1.003-1.109-.385-3.996-2.847-6.957-6.22-8.218"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "nonzero",
  d: "m29.166 9.984 1.65-1.155A16.935 16.935 0 0 1 35 20c0 9.389-7.611 17-17 17S1 29.389 1 20 8.611 3 18 3c.336 0 .67.01 1 .029v2.004C18.67 5.01 18.336 5 18 5 9.716 5 3 11.716 3 20c0 8.284 6.716 15 15 15 8.284 0 15-6.716 15-15 0-3.85-1.45-7.36-3.834-10.016Z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(21)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 10,
  x: 4,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 10,
  x: 4,
  rx: 1,
  transform: "rotate(-90 5 5)"
})))));
export { SvgIcoTooltipSignup as ReactComponent };
export default __webpack_public_path__ + "assets/media/ico-tooltip-signup.27689d9bd7ee754831a49a895a7640de.svg";